module.exports = __webpack_public_path__ + "static/img/6.c2b8539.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/zh/6.png
// module id = Vere
// module chunks = 0